/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect } from "react";
import Logo from "../../static/Logo.svg";

import clutch from "../../static/reviewPlatform/clutch.svg";
import upwork from "../../static/reviewPlatform/upwork.svg";

import {
  LinkFooter,
  LinksFooter,
  LinkImage,
  FooterCustom,
  MainInfo,
  GenQuestion,
  WithAddress,
  Address,
  ReviewPlatform,
  LinkReview,
  HrCustom,
  WithLogo,
  Button,
  BorderDIV,
  MiniText,
  LeanCanvasDiv,
  DIVAddress,
} from "./styles";

import Media from "./indexMedia";

const Footer = ({ origin }) => {
  const links = [
    { link: "https://clutch.co/profile/fulcrum", img: clutch },
    {
      link: "https://www.upwork.com/ag/fulcrum/",
      img: upwork,
    },
  ];
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (
      window.location.pathname === "/projects" ||
      window.location.pathname.startsWith("/projects#")
    ) {
      setActiveTab("projects");
    } else if (
      window.location.pathname === "/blog" ||
      window.location.pathname.startsWith("/blog/")
    ) {
      setActiveTab("blog");
    } else if (window.location.pathname === "/services") {
      setActiveTab("services");
    } else if (window.location.pathname === "/about") {
      setActiveTab("about");
    } else if (window.location.pathname === "/calculator") {
      setActiveTab("calculator");
    } else {
      setActiveTab("");
    }
  }, []);
  return (
    <>
      <FooterCustom style={{ maxWidth: "1920px", margin: "auto" }}>
        <WithLogo itemscope itemtype="https://schema.org/LocalBusiness">
          <span style={{ display: "none" }} itemProp="name">
            Fulcrum
          </span>
          <LinkImage href="/">
            <img src={Logo} alt="logo" />
          </LinkImage>
          <MainInfo>
            <LinksFooter>
              <LinkFooter
                href={`${origin}/projects`}
                id={activeTab === "projects" && "active"}
              >
                Projects
              </LinkFooter>
              <LinkFooter
                href={`${origin}/services`}
                id={activeTab === "services" && "active"}
              >
                Services
              </LinkFooter>

              <LinkFooter
                href={`${origin}/about`}
                id={activeTab === "about" && "active"}
              >
                About
              </LinkFooter>
              <LinkFooter
                id={activeTab === "blog" && "active"}
                href={`${origin}/blog`}
              >
                Blog
              </LinkFooter>
              <LinkFooter
                id={activeTab === "calculator" && "active"}
                href={`${origin}/calculator`}
              >
                Estimate app
              </LinkFooter>
            </LinksFooter>
            <WithAddress>
              <BorderDIV>
                <DIVAddress>
                  <GenQuestion>General questions:</GenQuestion>
                  <Address>
                    <a
                      href="https://www.google.com/maps/place/Avenue+Peremogi,+26,+%D0%9A%D0%B8%D0%B5%D0%B2,+02000/@50.451405,30.4659273,17z/data=!3m1!4b1!4m5!3m4!1s0x40d4ce83c23be29f:0xb70f1efa66110d4c!8m2!3d50.4514016!4d30.468116"
                      itemProp="address"
                      style={{ textDecoration: "underline" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Kyiv, Peremohy Avenue 42
                    </a>
                    <br />
                    <br />
                    <a
                      itemProp="telephone"
                      href="tel:+16469804236"
                      style={{ textDecoration: "underline" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +1 (646) 980-42-36
                    </a>
                    <br />
                    <br />
                    <a
                      itemProp="email"
                      style={{ textDecoration: "underline" }}
                      href="mailto:hello@fulcrum.rocks"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      hello@fulcrum.rocks
                    </a>
                  </Address>
                </DIVAddress>
                <LeanCanvasDiv>
                  <GenQuestion>Lean Canvas:</GenQuestion>
                  <MiniText>
                    Lean Canvas is an adapted version of Business Canvas model
                    by Alex Osterwalder.
                  </MiniText>
                  <Button href="https://canvas.fulcrum.rocks/">Create</Button>
                </LeanCanvasDiv>
              </BorderDIV>
              <ReviewPlatform>
                {links.map((key, i) => (
                  <LinkReview
                    href={key.link}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    key={i}
                  >
                    <img
                      style={{ objectFit: "contain", height: "auto" }}
                      src={links[i].img}
                      alt="reviewPlatform"
                    />
                  </LinkReview>
                ))}

                {/* <LinkReview
                  rel="dofollow"
                  target="_blank"
                  href="https://www.topdevelopers.co/directory/mobile-app-developers"
                >
                  <img
                    src="https://www.topdevelopers.co/assets/badges/app/Badges-Mobile-App-Developers-2020.png"
                    alt="TopDevelopers.co"
                    title="TopDevelopers.co"
                    style={{ height: "80px", width: "80px" }}
                  />
                </LinkReview> */}

                {/* <div>
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="https://www.goodfirms.co/company/fulcrum-rocks"
                  >
                    <img
                      style={{
                        width: '150px',
                        position: 'relative',
                        top: '-0.5rem',
                      }}
                      src="https://goodfirms.s3.amazonaws.com/badges/blue-button/app-development.svg"
                      alt="GoodFirms Badge"
                    />
                  </a>
                </div> */}
              </ReviewPlatform>
            </WithAddress>
          </MainInfo>
        </WithLogo>

        <HrCustom />
        <Media />
      </FooterCustom>
    </>
  );
};

export default Footer;
